exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-email[data-v-86aee2ee] {\n  margin-top: 10px;\n}\n", ""]);

// exports
